function executeDefineFunction(definer, args) {
    if (typeof definer === 'function') {
        const featureService = definer(...(args ?? []));
        return Array.isArray(featureService) ? featureService : [featureService];
    }
    return [definer];
}
function getDefinerName(definer) {
    if (typeof definer === 'function') {
        return definer.name || '?';
    }
    return definer && definer.id;
}
export function createFeatureServices(bundle, args, logger, ignoreServiceIds = []) {
    const serviceDefinitionsToLoad = [];
    const ignoreSet = new Set(ignoreServiceIds);
    Object.entries(bundle).forEach(([featureServiceId, definer]) => {
        if (ignoreSet.has(featureServiceId)) {
            logger.info(`[service-loading]: skipping ${featureServiceId}, either disabled by config or already loaded externally.`);
            return;
        }
        const params = args[featureServiceId];
        logger.info(`[service-loading]: executing define function with function name ${getDefinerName(definer)} for ${featureServiceId}, params:`, params);
        const featureServiceDefinitions = executeDefineFunction(definer, params);
        logger.debug(`loaded feature service ID - ${featureServiceDefinitions
            .map((defintion) => defintion.id)
            .join(' | ')} === ${featureServiceId} - expected feature service ID`);
        if (featureServiceDefinitions.some((definition) => definition.id === featureServiceId)) {
            serviceDefinitionsToLoad.push(...featureServiceDefinitions);
        }
        else {
            logger.error(`[service-loading]: loading of ${featureServiceId} failed. See previous logs in info or debug mode`);
        }
    });
    return serviceDefinitionsToLoad;
}
//# sourceMappingURL=create.js.map